import {useMutation, UseMutationResult} from '@tanstack/react-query';
import {useLocale} from 'state/locale';
import Api from 'types/api';
import {request} from 'utils/request-axios';

type DeletePossibleResponses = Api.Response.SuccessAxios<
    | 'client_list_view_redirect'
    | 'client_summary_view_redirect'
    | 'document_item_view_redirect',
    {mid: string}
>;

export const useUndelete = (): UseMutationResult<
    DeletePossibleResponses,
    Error,
    {
        url: string;
    }
> => {
    const locale = useLocale();

    return useMutation(({url}) =>
        request({
            locale,
            method: 'POST',
            url: `/ui/history/events${url}undelete/`,
        }),
    );
};

type ExportPossibleResponses =
    Api.Response.RedirectAxios<'history_downloads_view'>;

export const useExport = (): UseMutationResult<
    ExportPossibleResponses,
    Error,
    {formData: Record<string, unknown>}
> => {
    const locale = useLocale();

    return useMutation(({formData}) =>
        request({
            formData,
            locale,
            method: 'POST',
            url: '/ui/history/events/export/',
        }),
    );
};
